export enum OnPremAssetQueryKey {
    OnPremAssetDetails = "on-prem-asset-details",
    OnPremAssetOperations = "on-prem-asset-operations"
}
